import React, { useState, useEffect } from 'react';
import { supabase } from '../supabase';

const ServiceUnavailableMessage = ({ isAnonymous, userId }) => {
  const [email, setEmail] = useState('');
  const [saved, setSaved] = useState(false);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  // For logged-in users, auto-save their email once on mount
  useEffect(() => {
    if (!isAnonymous && userId) {
      supabase.auth.getUser().then(({ data }) => {
        const userEmail = data?.user?.email;
        if (userEmail) {
          supabase.from('service_waitlist').insert({ email: userEmail, user_id: userId })
            .then(() => setSaved(true))
            .catch(() => {}); // Ignore duplicate key errors (already on list)
        }
      });
    }
  }, [isAnonymous, userId]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email || !email.includes('@')) {
      setError('Please enter a valid email address.');
      return;
    }
    setSaving(true);
    setError('');
    const { error: insertError } = await supabase
      .from('service_waitlist')
      .insert({ email: email.trim().toLowerCase() });

    if (insertError && insertError.code === '23505') {
      // Already on the list — treat as success
      setSaved(true);
    } else if (insertError) {
      setError('Something went wrong. Please try again.');
    } else {
      setSaved(true);
    }
    setSaving(false);
  };

  return (
    <div style={{
      backgroundColor: '#FFF8F0',
      border: '1px solid #F5C99B',
      borderRadius: '12px',
      padding: '14px 16px',
      fontSize: '14px',
      color: '#2A324B',
      maxWidth: '320px'
    }}>
      <div style={{ display: 'flex', alignItems: 'flex-start', gap: '8px', marginBottom: isAnonymous && !saved ? '12px' : '0' }}>
        <span style={{ fontSize: '16px', flexShrink: 0 }}>⚠️</span>
        <span>
          Our analysis service is temporarily unavailable. Please try again in a few minutes.
          {!isAnonymous && saved && (
            <span style={{ display: 'block', marginTop: '6px', color: '#7A6652', fontSize: '13px' }}>
              We'll email you when it's back up.
            </span>
          )}
        </span>
      </div>

      {isAnonymous && !saved && (
        <form onSubmit={handleSubmit} style={{ display: 'flex', gap: '6px' }}>
          <input
            type="email"
            value={email}
            onChange={e => setEmail(e.target.value)}
            placeholder="your@email.com"
            style={{
              flex: 1,
              padding: '7px 10px',
              borderRadius: '8px',
              border: '1px solid #E8D5C0',
              fontSize: '13px',
              outline: 'none',
              backgroundColor: '#fff'
            }}
          />
          <button
            type="submit"
            disabled={saving}
            style={{
              padding: '7px 12px',
              borderRadius: '8px',
              backgroundColor: '#341C1C',
              color: '#fff',
              border: 'none',
              fontSize: '13px',
              cursor: saving ? 'not-allowed' : 'pointer',
              opacity: saving ? 0.7 : 1,
              whiteSpace: 'nowrap'
            }}
          >
            {saving ? '…' : 'Notify me'}
          </button>
        </form>
      )}

      {isAnonymous && saved && (
        <p style={{ margin: '8px 0 0', color: '#7A6652', fontSize: '13px' }}>
          Got it — we'll email you when it's back up.
        </p>
      )}

      {error && (
        <p style={{ margin: '6px 0 0', color: '#C0392B', fontSize: '13px' }}>{error}</p>
      )}
    </div>
  );
};

export default ServiceUnavailableMessage;
